import { Reveal } from "@/components/Motion";
import { TextLink, ConsultButton } from "@/components/Buttons";
import { PLAN_OPTIONS, QUOTE_PROCESS, QUOTE_CTA } from "@/data/site";

const CityQuote = ({ name }) => (
  <div data-testid="city-quote" className="rounded-[4px] bg-[#14263D] p-8 text-white md:p-10">
    <p className="font-mono text-xs uppercase tracking-[0.2em] text-[#f0b3b7]">Personalized quotes</p>
    <h3 className="mt-3 font-display text-3xl font-semibold md:text-4xl">Home Watch plans in {name}</h3>
    <ul className="mt-6 divide-y divide-white/10 border-y border-white/20">
      {PLAN_OPTIONS.map(([t]) => <li key={t} className="py-3 text-base text-white/90">{t}</li>)}
    </ul>
    {QUOTE_PROCESS.map((p) => <p key={p} className="mt-5 text-sm leading-relaxed text-white/85">{p}</p>)}
    <div className="mt-8 flex flex-wrap items-center gap-6">
      <ConsultButton testId="city-quote-btn" label={QUOTE_CTA} dark />
      <TextLink to="/plans-and-pricing" testId="city-pricing-link" light>Home Watch Plans</TextLink>
    </div>
  </div>
);

export const CityDetails = ({ c }) => (
  <section data-testid="city-details" className="bg-white pb-20 md:pb-28">
    <div className="mx-auto grid max-w-[1400px] gap-12 px-5 md:px-10 lg:grid-cols-12">
      <div className="space-y-10 lg:col-span-6">
        {c.sections.map(([title, text], i) => (
          <Reveal key={title} delay={i * 0.05}>
            <h2 className="font-display text-3xl font-semibold text-[#14263D] md:text-4xl">{title}</h2>
            <p className="mt-4 text-base leading-relaxed text-[#5F6B76] md:text-lg">{text}</p>
          </Reveal>
        ))}
        <Reveal><TextLink to="/hurricane-season-home-watch" testId="city-hurricane-link">Hurricane season home watch</TextLink></Reveal>
      </div>
      <Reveal className="lg:col-span-6"><CityQuote name={c.name} /></Reveal>
    </div>
  </section>
);
